<template>
    <vehicles />
  </template>
  
  <script>
  import vehicles from "@/components/3pl/Settings/Vehicles/EditVehicle/EditVehicleFleet.vue";
  export default {
    components: {
      vehicles,
    },
  };
  </script>
  
  <style></style>
  